import {Logger} from "platform/logger/Logger";
import Script from "platform/network/script/Script";
import {
    IOptimove,
    OptimoveEventData,
    OptimoveIdentifyProps,
    OptimoveTrackEvent,
    OptimoveWebInitProps
} from "platform/optimove/IOptimove";
import {Environment} from "platform/enum/Environment";
import Utils from "platform/util/Utils";
import {OptimoveEventName} from "platform/optimove/OptimoveEventName";

const logger: Logger = Logger.Of("OptimoveWeb");

export class OptimoveWeb implements IOptimove {

    private static _instance: IOptimove;
    private _initialized: boolean = false;

    private _brandId: number;
    private _brandName: string;
    private _language: string;
    private _environment: Environment;
    private _test: boolean;
    private _leadId: number;
    private _userId: number;
    private _accountId: number;

    public static instance(): IOptimove {
        return this._instance || (this._instance = new this());
    }

    public init(props: OptimoveWebInitProps) {
        if (this._initialized) {
            logger.info("Optimove already initialized.");
        }
        logger.info("Initialize Optimove with next params:", props);
        const url = props.sdkUrl.replace("${tenantId}", props.tenantId).replace("${tenantToken}", props.tenantToken)
        Script.injectScript(url, "optimoveSDK", () => {
                logger.info("Optimove successful initialized.");
                this._brandId = props.brandId;
                this._brandName = props.brandName;
                this._language = props.language;
                this._environment = props.environment;
                this._test = props.test;
                this.initPushReceivedListener();

                this._initialized = true;
            }, () => {
                logger.info("Failed init Optimove sdk.");
            });
    }

    private initPushReceivedListener() {
        window["optimoveSDK"].API.setPushReceivedListener((push) => {
            logger.info("optimoveSDK pushReceivedListener. Push received: ", push);
        });
        window["optimoveSDK"].API.setPushOpenedListener((push) => {
            logger.info("optimoveSDK pushOpenedListener. Push opened: ", push);
        });
    }


    identify(props: OptimoveIdentifyProps): void {
        this._leadId = props.leadId;
        this._userId = props.userId;
        this._accountId = props.accountId;
        this.setLeadId(`${props.leadId}`);
    }

    public setLanguage(lang: string) {
        this._language = lang;
    }

    public setAccountId(accountId: number) {
        this._accountId = accountId;
    }

    private setLeadId(leadId: string) {
        if (this._initialized) {
            window["optimoveSDK"].API.setUserId(leadId);
        }
    }

    private setUserEmail(email: string) {
        if (this._initialized) {
            window["optimoveSDK"].API.setUserEmail(email);
        }
    }

    public track(eventName: OptimoveEventName, parameters: OptimoveTrackEvent) {
        if (this._initialized) {
            const eventData: OptimoveEventData = {
                event: eventName,
                lead_id: this._leadId,
                user_id: this._userId,
                account_id: this._accountId,
                brand_name: this._brandName,
                brand_id: this._brandId,
                language: this._language,
                test: this._test,
                environment: this._environment,
                source: parameters.source,
                ...(Utils.isNotNull(parameters.symbolId) ? {symbol_id: parameters.symbolId} : {}),
                ...(Utils.isNotNull(parameters.symbolName) ? {symbol_name: parameters.symbolName} : {}),
            };
            window["optimoveSDK"].API.reportEvent(eventName, eventData, null, `${this._leadId}`);
        }
    }

    public signOutUser() {
        if (this._initialized) {
            window["optimoveSDK"].API.signOutUser();
        }
    }

    public preferenceCenterShowUI(type: number) {
        if (this._initialized) {
            window["optimoveSDK"].API.preferenceCenter.showUi(type);
        }
    }
}
